import {AppGlobal} from '../common/app.global';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {GlobalFunction} from '../common/core/global_function';
import {MenuItem} from 'primeng/components/common/menuitem';
import {EvaluationBaseComponent} from './evaluation-base.component';

export class BaseComponent {

  crumbs: MenuItem[];
  homeCrb: MenuItem;
  createRecordByUser;
  ownerSchool;
  isUpdateMode: boolean = false;
  mentorGroupList = [];
  mentorActivityList = [];
  valueBeforeUpdate: any;

  constructor(public appGlobal: AppGlobal,
              public route: ActivatedRoute,
              public router: Router,
              public _location: Location
              ) {

    this.initReferRole();
    this.initRoleValue();

    if (!this.route.snapshot['_routerState'].url.startsWith('/' + appGlobal.prefixUrlRole)
    && !this.route.snapshot['_routerState'].url.includes('/dashboard/')) {
      this.router.navigate(['/' + appGlobal.prefixUrlRole + '/error']);
    }
  }

  backToPreviousPage() {
    this._location.back();
  }

  reloadPage() {
   /* $(window).bind('beforeunload', function(){
      return '>>>>>Before You Go<<<<<<<< \n Your custom message go here';
    });*/

    $(window).bind('beforeunload', function(){
      return '';
    });
  }
/*
  confirmBack() {
    window.onbeforeunload = function(evt)
    {
      if (typeof evt == 'undefined') {
        evt = window.event;
      }
      if (evt) {
        return 'If you leave this page, your information will not be updated.';
      }
    };
  }*/


  displayLabelByKey(nameKey, myArray) {
    return GlobalFunction.getLabelFromArrayByKey(nameKey, myArray);
  }

  isMentor() {
    return this.appGlobal.role == this.appGlobal.roleMentor;
  }
  isSchoolAdmin() {
    return this.appGlobal.role == this.appGlobal.roleSchoolAdmin;
  }
  isSystemAdmin() {
    return this.appGlobal.role == this.appGlobal.roleSystemAdmin;
  }
  isSuperAdmin() {
    return this.appGlobal.role == this.appGlobal.roleSuperAdmin;
  }
  isReferOtherRole() {
    let actuallyRole = parseInt(localStorage.getItem(this.appGlobal.roleLocalKey));
    if ((actuallyRole == this.appGlobal.roleSuperAdmin || actuallyRole == this.appGlobal.roleSystemAdmin) && this.appGlobal.refer_role && this.appGlobal.refer_prefixUrlRole) {
      return true;
    }
    return false;
  }

  isUserNotOwner() {
    return this.isMentorNotOwner();
  }

  isUserNotOwnerGroup() {
    if (!this.isMentorInGroup()) {
      return true;
    }
    if (this.isSchoolAdminNotOwner()) {
      return true;
    }
    return false;
  }

  isMentorNotOwner() {
    return (this.isMentor() && this.createRecordByUser != this.appGlobal.emailCurrentUserLogin);
  }
  isMentorOwner() {
    return (this.isMentor() && this.createRecordByUser == this.appGlobal.emailCurrentUserLogin);
  }
  isSchoolAdminNotOwner() {
    return (this.isSchoolAdmin() && this.createRecordByUser != this.appGlobal.emailCurrentUserLogin);
  }
  isSchoolAdminOwner() {
    return (this.isSchoolAdmin() && this.createRecordByUser == this.appGlobal.emailCurrentUserLogin);
  }

  canManageGroupStudents() {
    return this.isSuperAdmin() || this.isSystemAdmin() || this.isMentorInGroup() || this.isSchoolAdmin();
  }
  canManageActivityStudents() {
    return this.isSuperAdmin() || this.isSystemAdmin() || this.isMentorInActivity() || this.isSchoolAdmin();
  }
  canManageDeleteStudentsFromGroup() {
    return this.isSuperAdmin() || this.isSystemAdmin() || this.isMentorOwner() || this.isSchoolAdmin();
  }

  canAddGroupActivities() {
    return this.isSuperAdmin() || this.isSystemAdmin() || this.isMentorInGroup() || this.isSchoolAdmin();
  }

  canManageGroupDocuments() {
    return this.isSuperAdmin() || this.isSystemAdmin() || this.isMentorInGroup() || this.isSchoolAdmin();
  }
  canManageActivityDocuments() {
    return this.isSuperAdmin() || this.isSystemAdmin() || this.isMentorInActivity() || this.isSchoolAdmin();
  }

  backToSuperAdmin() {
    localStorage.removeItem(this.appGlobal.refer_prefixUrlRoleLocalKey);
    localStorage.removeItem(this.appGlobal.refer_roleNameLocalKey);
    localStorage.removeItem(this.appGlobal.refer_roleLocalKey);
    localStorage.removeItem(this.appGlobal.refer_emailCurrentUserLoginLocalKey);
    localStorage.removeItem(this.appGlobal.refer_schoolCurrentUserLoginLocalKey);
    localStorage.removeItem(this.appGlobal.refer_profileImageUrlLocalKey);

    delete this.appGlobal.refer_prefixUrlRole;
    delete this.appGlobal.refer_roleName;
    delete this.appGlobal.refer_role;
    delete this.appGlobal.refer_emailCurrentUserLogin;
    delete this.appGlobal.refer_schoolCurrentUserLogin;
    delete this.appGlobal.refer_profileImageUrlLocalKey;

    this.initRoleValue();
    this.router.navigate(['/' + this.appGlobal.prefixUrlRole + '/dashboard/index']);
  }

  initReferRole() {
    this.appGlobal.refer_prefixUrlRole = localStorage.getItem(this.appGlobal.refer_prefixUrlRoleLocalKey);
    this.appGlobal.refer_roleName = localStorage.getItem(this.appGlobal.refer_roleNameLocalKey);
    this.appGlobal.refer_role = parseInt(localStorage.getItem(this.appGlobal.refer_roleLocalKey));
    this.appGlobal.refer_emailCurrentUserLogin = localStorage.getItem(this.appGlobal.refer_emailCurrentUserLoginLocalKey);
    this.appGlobal.refer_schoolCurrentUserLogin = localStorage.getItem(this.appGlobal.refer_schoolCurrentUserLoginLocalKey);
    this.appGlobal.refer_profileImageUrl = localStorage.getItem(this.appGlobal.refer_profileImageUrlLocalKey);
  }

  initRoleValue() {
    this.appGlobal.prefixUrlRole = this.appGlobal.refer_prefixUrlRole
      ? this.appGlobal.refer_prefixUrlRole : localStorage.getItem(this.appGlobal.prefixUrlRoleLocalKey);
    this.appGlobal.roleName = this.appGlobal.refer_roleName
      ? this.appGlobal.refer_roleName : localStorage.getItem(this.appGlobal.roleNameLocalKey);
    this.appGlobal.role = this.appGlobal.refer_role
      ? this.appGlobal.refer_role : parseInt(localStorage.getItem(this.appGlobal.roleLocalKey));
    this.appGlobal.emailCurrentUserLogin = this.appGlobal.refer_emailCurrentUserLogin
      ? this.appGlobal.refer_emailCurrentUserLogin : localStorage.getItem(this.appGlobal.emailCurrentUserLoginLocalKey);
    this.appGlobal.schoolCurrentUserLogin = this.appGlobal.refer_schoolCurrentUserLogin
      ? this.appGlobal.refer_schoolCurrentUserLogin : localStorage.getItem(this.appGlobal.schoolCurrentUserLoginLocalKey);
    this.appGlobal.profileImageUrl = this.appGlobal.refer_profileImageUrl
      ? this.appGlobal.refer_profileImageUrl : localStorage.getItem(this.appGlobal.profileImageUrlLocalKey);
    this.homeCrb = {icon: 'pi pi-home', routerLink: ['/' + this.appGlobal.prefixUrlRole]};
  }

  isMentorInGroup() {
    // Not check with other role
    if (!this.isMentor()) {
      return true;
    }
    if (this.mentorGroupList && this.mentorGroupList.length > 0) {
      for (let mentor of this.mentorGroupList) {
        if (mentor == this.appGlobal.emailCurrentUserLogin) {
          return true;
        }
      }
    }
    return this.isMentorOwner();
  }
  isMentorInActivity() {
    // Not check with other role
    if (!this.isMentor()) {
      return true;
    }
    if (this.mentorActivityList && this.mentorActivityList.length > 0) {
      for (let mentor of this.mentorActivityList) {
        if (mentor == this.appGlobal.emailCurrentUserLogin) {
          return true;
        }
      }
    }
    return this.isMentorOwner();
  }

  isRecordOfOwnerSchool() {
    return this.isSchoolAdmin() && this.ownerSchool == this.appGlobal.schoolCurrentUserLogin;
  }
  isRecordNotOfOwnerSchool() {
    return this.isSchoolAdmin() && this.ownerSchool != this.appGlobal.schoolCurrentUserLogin;
  }

  isSuccessUpdated(responseStatus) {
    let ok_status = [200, 201, 202, 203, 204];
    return ok_status.includes(responseStatus);
  }

  createPortableAngularUrl(routeCommands: any[]) {
    let url = this.router.createUrlTree(routeCommands);
    return this._location.prepareExternalUrl(url.toString());
  }

}



// WEBPACK FOOTER //
// ./src/app/application/base.component.ts